import React, { useEffect, useState, createContext } from 'react';
import { Language, translations, Translations } from '../translations';
type LanguageContextType = {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations;
};
export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
type LanguageProviderProps = {
  children: ReactNode;
};
export function LanguageProvider({
  children
}: LanguageProviderProps) {
  const [language, setLanguageState] = useState<Language>(() => {
    // Load from localStorage or default to English
    const saved = localStorage.getItem('kbin-language');
    return saved as Language || 'en';
  });
  useEffect(() => {
    // Save to localStorage whenever language changes
    localStorage.setItem('kbin-language', language);
  }, [language]);
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
  };
  const value: LanguageContextType = {
    language,
    setLanguage,
    t: translations[language]
  };
  return <LanguageContext.Provider value={value} data-id="element-302">
      {children}
    </LanguageContext.Provider>;
}